import {LocaleStore} from "./localeStore";
import {UserStore} from "./userStore";
import {autorun} from "mobx";

export const userStore = new UserStore();
export const localeStore = new LocaleStore();